import { Popover as P } from 'radix-ui'
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react'
import { cn } from '@/lib/utils'

export const Popover = P.Root
export const PopoverTrigger = P.Trigger
export const PopoverAnchor = P.Anchor
export const PopoverClose = P.Close

export const PopoverContent = forwardRef<ElementRef<typeof P.Content>, ComponentPropsWithoutRef<typeof P.Content>>(
  ({ className, align = 'start', sideOffset = 6, ...props }, ref) => (
    <P.Portal>
      <P.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn('z-50 rounded-lg border border-border bg-surface text-sm shadow-md animate-in focus:outline-none', className)}
        {...props}
      />
    </P.Portal>
  ),
)
PopoverContent.displayName = 'PopoverContent'
